// Which audience this build serves. Set at build time via REACT_APP_SITE_MODE.
// The SAME codebase is built twice: the owner site (pettrek.co.za) and the
// handler site (handlers.pettrek.co.za). Everything role-specific branches on
// these flags so the two builds share components, auth, and the API client.
export const SITE_MODE = (process.env.REACT_APP_SITE_MODE || 'owner').toLowerCase();

export const isHandlerSite = SITE_MODE === 'handler';
export const isOwnerSite = !isHandlerSite;

// The sibling site's URL, for cross-links ("are you a handler? / a pet owner?").
export const OWNER_SITE_URL =
  process.env.REACT_APP_OWNER_SITE_URL || 'https://pettrek.co.za';
export const HANDLER_SITE_URL =
  process.env.REACT_APP_HANDLER_SITE_URL || 'https://handlers.pettrek.co.za';
